import React, {useEffect, useState} from 'react'
import {client} from '../utils/api-client'

const CheckStatus = () => {
  const [data, setData] = useState({status: 'Loading...', timestamp_gmt: ''})

  useEffect(() => {
    async function fetchStatus() {
      try {
        const result = await client('check-status')
        setData(result)
      } catch (error) {
        setData({status: 'Error fetching status', timestamp_gmt: ''})
      }
    }

    fetchStatus()
  }, [client])

  return (
    <>
      <p>{data.status}</p>
      <p>{data.timestamp_gmt}</p>
    </>
  )
}

export default CheckStatus
